import { render, staticRenderFns } from "./IndexRedesignC.vue?vue&type=template&id=37d563b0"
import script from "./IndexRedesignC.vue?vue&type=script&lang=js"
export * from "./IndexRedesignC.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports